<!-- Assign Worker -->
<div class="modal right fade" id="assignWorker" tabindex="-1" role="dialog" aria-labelledby="assignWorkerLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-title">
                    <h4 id="newChatLabel">Assign Order</h4>
                    <span>{{ selectedWork.unique }}</span>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
                                    <div class="form-group floating">
                                        <select 
                                            ng-model="selectedWork.worker_id" 
                                            class="form-control"
                                            style="display: none !important;"
                                            ng-options="worker.id as worker.full_name for worker in data.workers">
                                            <option value="">Select Driver</option>
                                        </select>

                                        <select class="selectpicker" 
                                            title="By Driver"
                                            data-live-search="true"
                                            data-selected-text-format="count" 
                                            data-language="tr_TR"
                                            ng-model="selectedWork.worker_id"
                                            ng-disabled="route.status == 1"
                                            ng-keyup="$event.keyCode == 13 && refreshData()"
                                            data-style="btn-primary">
                                            <option 
                                                ng-repeat="iWorker in data.workers | orderBy:['status']"
                                                data-select-watcher 
                                                data-last="{{$last}}" 
                                                class="worker-{{iWorker.vehicle}}"
                                                ng-selected="iWorker.id == route.worker_id"
                                                value="{{iWorker.id}}">
                                                {{iWorker.full_name}}
                                            </option>
                                        </select>

                                    </div>
                                    <div class="form-group floating">
                                        <button type="submit" 
                                            ng-click="assignWorker()" 
                                            class="hod-button blue">
                                            <span>Assign</span>
                                        </button>
                                        <button type="button" 
                                            class="hod-button blue" 
                                            data-dismiss="modal" 
                                            data-toggle="modal" 
                                            data-target="#orderDetail">
                                            Cancel
                                        </button>
                                    </div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>

<!-- Change Work Status -->
<div class="modal right fade" id="changeWorkStatus" tabindex="-1" role="dialog" aria-labelledby="changeWorkStatusLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-title">
                    <h4 id="newChatLabel">Change Order Status</h4>
                    <span>{{ selectedWork.unique }}</span>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
                                    <div class="form-group floating">
                                        <select ng-model="selectedWork.status" 
                                            ng-options="item.name for item in data.steps track by item.id"
                                            class="form-control">
                                        </select>
                                        <label>Order Status </label>
                                    </div>
                                    <div class="form-group floating w-100" ng-show="selectedWork.status.value === 'failed' || selectedWork.status.value === 'cancel'">
                                        <select class="selectpicker w-100" data-live-search="true"
                                            title="Select Reason"
                                            required
                                            data-selected-text-format="count" data-language="tr_TR"
                                            ng-model="selectedWork.cancel_reason" data-style="btn-primary">
                                            <option ng-repeat="item in cancelReasons" data-select-watcher 
                                                data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group floating">
                                        <button type="submit" 
                                            ng-click="changeWorkStatus()" 
                                            class="hod-button blue">
                                            <span>UPDATE</span>
                                        </button>
                                        <button type="button" 
                                            class="hod-button blue" 
                                            data-dismiss="modal" 
                                            data-toggle="modal" 
                                            data-target="#orderDetail">
                                            Cancel
                                        </button>
                                    </div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>

<!-- Delete Work -->
<div class="modal info-box fade" id="deleteWork" tabindex="-1" role="dialog" aria-labelledby="deleteWorkLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content p25">
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <p class="pb25">Are you sure you want to delete ?</p>
                    </div>
                </div>

                <div class="">
                    <button type="submit" class="btn pull-right btn-danger" ng-click="deleteWork()">
                        Delete
                    </button>
                    <button type="button" class="btn pull-left btn-default" data-dismiss="modal">Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Delete Task -->
<div class="modal fade" id="deleteTask" tabindex="-1" role="dialog" aria-labelledby="deleteTaskLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="deleteTaskLabel">Dikkat!</h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <p>Bu iş kalıcı olarak silinecektir. Bu işlem geri alınamaz!</p>
                        <strong>Devam etmek istiyor musunuz ?</strong>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="submit" class="btn pull-left btn-primary" ng-click="deleteTask()">Sil</button>
                <button type="button" class="btn pull-left btn-default" data-dismiss="modal" data-toggle="modal" data-target="#taskDetail" >İptal</button>
            </div>
        </div>
    </div>
</div>
    

<!-- Route Details -->
<div class="modal fade" id="routeDetail" tabindex="-1" role="dialog" aria-labelledby="routeDetailLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="routeDetailLabel">Yol Geçmişi</h4>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-md-12">
                        <div class="panel mt10">
                            <div id="map-history"></div>
                            <br>
                            <a href="#" class="btn btn-primary" ng-if="!routeMarkerVisible" ng-click="toggleMarkerVisible()">Pinleri Gizle</a>
                            <a href="#" class="btn btn-primary" ng-if="routeMarkerVisible" ng-click="toggleMarkerVisible()">Pinleri Göster</a>
                            
                        <!-- 
                            <div class="panel-body">
                                <div class="col-md-6">
                                    <strong>Teslimat Süresi : </strong> {{ selectedWork.time }} Dakika
                                </div>
                                <div class="col-md-6">
                                    <strong>Teslimat Mesafesi : </strong> 4.56 KM
                                </div>
                            </div>
                        -->
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="button" class="btn pull-left btn-default" data-dismiss="modal" data-toggle="modal" data-target="#orderDetail"> Kapat</button>
            </div>
        </div>
    </div>
</div>